import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import {AuthenticationService} from '../../services/authentication.service'
import { ProfileService } from 'src/app/services/profile.service';
import { DashboardService } from 'src/app/services/dashboard.service';
@NgModule({
    imports: [ RouterModule, CommonModule, MatButtonModule,MatTooltipModule ],
    declarations: [ NavbarComponent ],
    providers:[AuthenticationService,ProfileService,DashboardService],
    exports: [ NavbarComponent ]
})

export class NavbarModule {}
